class DeliveryEstimation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.messageSpan = this.querySelector('.delivery-estimation__message');

    this.cutoffTime = this.dataset.cutoff;
    this.deliveryDays = parseInt(this.dataset.deliveryDays);
    this.excludedDaysStr = (this.dataset.excludedDays || '').toUpperCase();
    this.excludedDatesStr = this.dataset.excludedDates || '';
    this.dayMap = {
      SUN: 0,
      SUNDAY: 0,
      MON: 1,
      MONDAY: 1,
      TUE: 2,
      TUES: 2,
      TUESDAY: 2,
      WED: 3,
      WEDS: 3,
      WEDNESDAY: 3,
      THU: 4,
      THUR: 4,
      THURS: 4,
      THURSDAY: 4,
      FRI: 5,
      FRIDAY: 5,
      SAT: 6,
      SATURDAY: 6,
    };

    const [excludedDays, excludedDates] = this.getExcludedDaysAndDates();
    this.excludedDays = excludedDates;
    this.excludedDates = excludedDates;

    this.excludedDayIndexes = excludedDays
      .map((d) => this.dayMap[d])
      .filter((d) => d !== undefined);

    this.init();
  }

  init() {
    // 1. Get current time in London
    const now = this.getLondonNow();

    // 2. Determine Dispatch Date
    const [cutoffHour, cutoffMinute] = this.cutoffTime.split(':').map(Number);
    const cutoffDate = new Date(now);
    cutoffDate.setHours(cutoffHour, cutoffMinute, 0, 0);

    let dispatchDate = new Date(now);

    // If after cutoff, start counting from tomorrow
    if (now > cutoffDate) {
      dispatchDate = this.addDays(dispatchDate, 1);
    }

    // Dispatch only moves forward when that day is in the exclusion list.
    // An empty list means every day, including Saturday and Sunday, is allowed.
    while (this.isExcluded(dispatchDate)) {
      dispatchDate = this.addDays(dispatchDate, 1);
    }

    // 3. Calculate Delivery Date
    let deliveryDate = new Date(dispatchDate);

    // Add the specific delivery timeframe
    // If timeframe is 1 day (Next Day), we add 1 day.
    // However, we need to ensure every day we step through is valid?
    // Or just the end result? usually "Next Day" means next *working* day.

    let daysToAdd = this.deliveryDays;
    while (daysToAdd > 0) {
      deliveryDate = this.addDays(deliveryDate, 1);
      if (!this.isExcluded(deliveryDate)) {
        daysToAdd--;
      }
    }

    // Final check (handled by loop above, but good to be safe)
    while (this.isExcluded(deliveryDate)) {
      deliveryDate = this.addDays(deliveryDate, 1);
    }

    this.messageSpan.innerHTML = `Get it delivered as soon as <span class="text-success">${this.formatDate(
      deliveryDate
    )}</span>`;
  }

  getExcludedDaysAndDates() {
    return [
      this.excludedDaysStr
        .split(',')
        .map((d) => d.trim())
        .filter((d) => d),
      this.excludedDatesStr
        .split(',')
        .map((d) => d.trim())
        .filter((d) => d),
    ];
  }

  getLondonDate(date) {
    return new Date(
      date.toLocaleString('en-US', { timeZone: 'Europe/London' })
    );
  }

  getLondonNow() {
    return this.getLondonDate(new Date());
  }

  isExcluded(date) {
    const day = date.getDay();
    const dateStr =
      date.getDate().toString().padStart(2, '0') +
      '/' +
      (date.getMonth() + 1).toString().padStart(2, '0');

    if (this.excludedDayIndexes.includes(day)) return true;
    if (this.excludedDates.includes(dateStr)) return true;
    return false;
  }

  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  formatDate(date) {
    const days = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    const dayName = days[date.getDay()];
    const dayOfMonth = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });

    let suffix = 'th';
    if (dayOfMonth === 1 || dayOfMonth === 21 || dayOfMonth === 31)
      suffix = 'st';
    else if (dayOfMonth === 2 || dayOfMonth === 22) suffix = 'nd';
    else if (dayOfMonth === 3 || dayOfMonth === 23) suffix = 'rd';

    return `${dayName} ${dayOfMonth}${suffix} ${month}`;
  }
}

customElements.define('delivery-estimation', DeliveryEstimation);
